(function (angular) {
    angular.module('bizPartEngage').directive('bizUnsubscribe', bizUnsubscribeDirective);
    angular.module('bizPartEngage').service('bizUnsubscribeService', bizUnsubscribeService);

    bizUnsubscribeDirective.$inject = ["bizCore"];
    bizUnsubscribeService.$inject = ["$http"]

    function bizUnsubscribeDirective(bizCore) {
        var directive = {
            restrict: "E",
            scope: {
            },
            templateUrl: bizCore.getView('core.directives.unsubscribe', "FrontEnd/Core/Directives/Views/Unsubscribe.html"),
            bindToController: true,
            controller: bizUnsubscribeController,
            controllerAs: "vm"
        };

        bizUnsubscribeController.$inject = ["bizUnsubscribeService"];

        function bizUnsubscribeController(bizUnsubscribeService) {
            var vm = this;

            vm.Logo = portalSettings['logo'];            

            vm.Init = Init;
            vm.GetEncodedQS = GetEncodedQS;
            vm.GetCategoriesByCode = GetCategoriesByCode;
            vm.ConfirmCategories = ConfirmCategories;
            vm.GetCategoryIdsToLink = GetCategoryIdsToLink;
            vm.IsCategoryOptIn = IsCategoryOptIn;

            function IsCategoryOptIn(category) {
                return category.CategoryType === 1;
            }

            function GetCategoryIdsToLink() {
                var catIds = [];
                for (var i = 0; i < vm.Categories.length; i++) {
                    var cat = vm.Categories[i];
                    var isChecked = cat.Checked;
                    var isOptIn = IsCategoryOptIn(cat);

                    //the user selects which categories they are NOT interested in
                    if (isOptIn && !isChecked) {
                        //if category is opt in, they should be added if they have not checked
                        catIds.push(cat.Id);
                    } else if (!isOptIn && isChecked) {
                        //if category is opt out, they should be added if they have checked
                        catIds.push(cat.Id);
                    }
                }
                return catIds;
            }

            function ConfirmCategories() {
                vm.Result = false;
                var catIds = vm.GetCategoryIdsToLink();

                if (vm.Code) {
                    bizUnsubscribeService.SaveCategoriesByCode(vm.Code, catIds).then((response) => {
                        console.log("SaveCategoriesByCode", response);
                        vm.Result = true;
                        var result = BizPartCoreHelpers.getResponseValue(response);
                        if (result.Success) {
                            vm.Success = true;
                        } else {
                            vm.Success = false;
                        }                        
                    });
                } else {
                    console.log("not implemented yet");
                }                
            };

            function GetEncodedQS() {
                return getParameterByNameFromUrl('c', location.href);
            }

            function GetCategoriesByCode(code) {
                bizUnsubscribeService.GetCategoriesByCode(code).then((response) => {
                    var categories = BizPartCoreHelpers.getResponseValue(response, []);
                    for (var i = 0; i < categories.length; i++) {
                        var cat = categories[i];
                        var isOptIn = vm.IsCategoryOptIn(cat);
                        if (isOptIn) {
                            //inverse opt in, as the user selects what they are NOT interested in.
                            cat.Checked = !cat.Checked;
                        }
                    }
                    vm.Categories = categories;
                    console.log("categories", vm.Categories);
                });
            }

            function Init() {
                vm.Code = vm.GetEncodedQS();
                console.log("code", vm.Code);

                if (vm.Code) {
                    GetCategoriesByCode(vm.Code);
                }
            }

            vm.$onInit = function () {
                vm.Init();
            }
        }

        return directive;
    }

    function bizUnsubscribeService($http) {
        var servicepath = siteRootPath + "api/genericsendcategory/";

        this.GetCategoriesByCode = function (code) {
            return $http.get(servicepath + "GetCategoriesForUserByCode", {
                params: {
                    code: code
                }
            });
        }

        this.SaveCategoriesByCode = function (code, catIds) {
            return $http.post(servicepath + "LinkCategoriesToUserByCode", {
                Code: code, CategoryIds: catIds
            });
        }
    }

})(window.angular);